/* Collection & search filtering without page reloads (Section Rendering API). */
(() => {
  const root = document.querySelector('[data-collection]');
  if (!root) return;
  const sectionId = root.dataset.sectionId;
  let ctrl;
  let timer;

  const openState = () => Array.from(root.querySelectorAll('.facet')).map((d) => d.open);

  const render = async (url, push = true) => {
    ctrl?.abort();
    ctrl = new AbortController();
    const wasOpen = openState();
    const panelOpen = root.querySelector('[data-facets-panel]')?.classList.contains('is-open');
    root.setAttribute('aria-busy', 'true');
    root.querySelector('[data-results]')?.classList.add('is-loading');
    try {
      const u = new URL(url, location.origin);
      u.searchParams.set('section_id', sectionId);
      const html = await (await fetch(u, { signal: ctrl.signal })).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-collection]');
      if (!fresh) { location.href = url; return; }
      ['[data-facets]', '[data-results]'].forEach((sel) => {
        const a = root.querySelector(sel);
        const b = fresh.querySelector(sel);
        if (a && b) a.replaceWith(b);
      });
      root.querySelectorAll('.facet').forEach((d, i) => { if (wasOpen[i]) d.open = true; });
      if (panelOpen) setPanel(true);
      bind();
      window.themeReveal && window.themeReveal();
      if (push) history.pushState({ facets: true }, '', url);
    } catch (err) {
      if (err.name !== 'AbortError') location.href = url;
    } finally {
      root.removeAttribute('aria-busy');
    }
  };

  const formUrl = (form) => {
    const params = new URLSearchParams();
    const defaultSort = form.querySelector('[data-sort]')?.dataset.default;
    new FormData(form).forEach((v, k) => {
      if (String(v).trim() === '' || (k === 'sort_by' && v === defaultSort)) return;
      params.append(k, v);
    });
    const qs = params.toString();
    return form.getAttribute('action') + (qs ? '?' + qs : '');
  };

  const setPanel = (on) => {
    const panel = root.querySelector('[data-facets-panel]');
    const toggle = root.querySelector('[data-facets-toggle]');
    if (!panel) return;
    panel.classList.toggle('is-open', on);
    toggle?.setAttribute('aria-expanded', String(on));
    if (matchMedia('(max-width: 899px)').matches) document.documentElement.style.overflow = on ? 'hidden' : '';
  };

  const bind = () => {
    const form = root.querySelector('[data-facets-form]');
    if (!form) return;
    form.addEventListener('change', () => {
      clearTimeout(timer);
      timer = setTimeout(() => render(formUrl(form)), 250);
    });
    form.addEventListener('submit', (e) => { e.preventDefault(); render(formUrl(form)); });
    root.querySelector('[data-facets-toggle]')?.addEventListener('click', () => setPanel(!root.querySelector('[data-facets-panel]').classList.contains('is-open')));
    root.querySelector('[data-facets-close]')?.addEventListener('click', () => setPanel(false));
    root.querySelectorAll('[data-facet-remove], [data-facets-clear], .pagination a').forEach((a) => a.addEventListener('click', (e) => {
      e.preventDefault();
      render(a.href);
      if (a.closest('.pagination')) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));
  };

  // Close desktop dropdowns when clicking outside.
  document.addEventListener('click', (e) => {
    if (matchMedia('(min-width: 900px)').matches && !e.target.closest('.facet')) {
      root.querySelectorAll('.facet[open]').forEach((d) => { d.open = false; });
    }
  });
  root.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { setPanel(false); root.querySelectorAll('.facet[open]').forEach((d) => { d.open = false; }); }
  });
  addEventListener('popstate', () => render(location.href, false));
  bind();
})();
